
import { MODULE } from "@/config/modules";
import { Module } from "@/models/module";
import {ModuleService} from "@/services/module-service";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			allModules: ModuleService.modules,
			selectedItems: [] as Module[]
		};
	},
	props: {
		multiple: Boolean,
		ignoredModules: {
			type: Array as ()=>MODULE[],
			default(){
				return [];
			}
		},
		title: String
	},
	computed: {
		shownModules():Module[]{
			return this.allModules.filter(m=>this.ignoredModules.find(ignoredModule=>m.id == ignoredModule) == null);
		},
		columns():IDataTableColumn[]{
			return [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Name",
					property: "name",
					width: "200px"
				}
			];
		}
	},
	watch: {
		"selectedItems.length"(){
			if (this.selectedItems.length == 1 && !this.multiple){
				this.$emit("input", this.selectedItems[0].id);
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.selectedItems.map(m=>m.id));
			this.close();
		}
	}
});
